import React from 'react';
import './style.js'
import { HeaderStyled } from './style.js';
import {
    Menu,
    MenuButton,
    MenuList,
    IconButton
  } from '@chakra-ui/react'
import { ArrowRotateLeft, Edit2, HambergerMenu, Message, Profile, Star1 } from 'iconsax-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedinIn, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

export default function Header() {

    return (
        <HeaderStyled>
            <a href='#' className='logo'><span>Pedro Lisboa</span> Developer</a>
            <nav className='linkNav'>
                <ul className='menu'>
                    <li><a href='#'>Início</a></li>
                    <li><a href='#Sobre'>Sobre</a></li>
                    <li><a href='#Projetos'>Projetos</a></li>
                    <li><a href='#Skills'>Habilidades</a></li>
                    <li><a href='#Contato'>Contato</a></li>
                </ul>
                <Menu>
                <MenuButton
                    className='menuBurger'
                    as={IconButton}
                    aria-label='Options'
                    icon={<HambergerMenu size="32" background="none" color="#0077FF"/>}
                    variant='outline'
                />
                <MenuList className='menuFlex'>
                    <a href='#'><ArrowRotateLeft size="32" color="#0077FF"/>
                        Início
                    </a>
                    <a href='#Sobre'><Profile size="32" color="#0077FF"/>
                        Sobre
                    </a>
                    <a href='#Projetos'><Edit2 size="32" color="#0077FF"/>
                        Projeto
                    </a>
                    <a href='#Skills'><Star1 size="32" color="#0077FF"/>
                        Habilidades
                    </a>
                    <a href='#Contato'><Message size="32" color="#0077FF"/>
                        Contato
                    </a>
                    <div className='divA'>
                        <a className='aIcon' href="https://api.whatsapp.com/send/?phone=%2B5588992710349&text&type=phone_number&app_absent=0" target="_blank"><FontAwesomeIcon icon={faWhatsapp} /></a>
                        <a className='aIcon' href="https://instagram.com/pedrowslisboa" target="_blank"><FontAwesomeIcon icon={faInstagram} /></a>
                        <a className='aIcon' href="https://github.com/Lisboaseyth" target="_blank"><FontAwesomeIcon icon={faGithub} /></a>
                        <a className='aIcon' href="https://www.linkedin.com/in/pedro-lisboa-a4b9a0235/" target="_blank"><FontAwesomeIcon icon={faLinkedinIn} /></a>
                    </div>
                </MenuList>
                </Menu>
            </nav>
        </HeaderStyled>
    )
}